import EmailValidator from './email'
import PasswordValidator from './password'
import EqualPasswordValidator from './equalPassword'
import IsEmptyValidator from './isEmpty'
import IsIntegerValidator from './isInteger'
import IsFloatValidator from './isFloat'
import IsNumberOrFloatValidator from './isNumber'
import IsYoutubeLink from './isYoutubeLink'
import IsPositiveNumberValidator from './isPositiveNumber'
import IsSisenseRefresh from './isSisenseRefresh'
import IsPositiveIntegerValidator from './isPositiveIntegerValidator'
import IsInvalidRange from './isInvalidRange'
import isInvalidConfirmPassword from './isInvalidConfirmPassword'
import isLessThen255Symbols from './isLessThen255Symbols'
import isLongitude from './isLongitude'
import isLatitude from './isLatitude'

export const VALIDATOR_EMAIL = 'email'
export const VALIDATOR_PASSWORD = 'password'
export const VALIDATOR_PASSWORDS_EQUAL = 'equalPassword'
export const VALIDATOR_IS_EMPTY = 'isEmpty'
export const VALIDATOR_IS_INTEGER = 'isInteger'
export const VALIDATOR_IS_POSITIVE_INTEGER = 'isPositiveInteger'
export const VALIDATOR_IS_NUMBER = 'isNumber'
export const VALIDATOR_IS_POSITIVE_NUMBER = 'isPositiveNumber'
export const VALIDATOR_IS_NUMBER_OR_FLOAT = 'isNumberOrFloat'
export const VALIDATOR_IS_YOUTUBE_LINK = 'isYoutubeLink'
export const VALIDATOR_IS_SISENSE_REFRESH = 'isSisenseRefresh'
export const VALIDATOR_IS_INVALID_RANGE = 'isInvalidRange'
export const VALIDATOR_CONFIRM_PASSWORD = 'isInvalidConfirm'
export const VALIDATOR_IS_LESS_THEN_255_SYMBOLS = 'IsLessThen255Symbols'
export const VALIDATOR_IS_LONGITUDE = 'IsLongitude'
export const VALIDATOR_IS_LATITUDE = 'IsLatitude'
// Сюда добавлять алиасы валидаторов в виде констант

const validators = {
  [VALIDATOR_EMAIL]: EmailValidator,
  [VALIDATOR_PASSWORD]: PasswordValidator,
  [VALIDATOR_IS_EMPTY]: IsEmptyValidator,
  [VALIDATOR_IS_INTEGER]: IsIntegerValidator,
  [VALIDATOR_IS_POSITIVE_INTEGER]: IsPositiveIntegerValidator,
  [VALIDATOR_IS_NUMBER]: IsFloatValidator,
  [VALIDATOR_IS_POSITIVE_NUMBER]: IsPositiveNumberValidator,
  [VALIDATOR_IS_NUMBER_OR_FLOAT]: IsNumberOrFloatValidator,
  [VALIDATOR_IS_YOUTUBE_LINK]: IsYoutubeLink,
  [VALIDATOR_PASSWORDS_EQUAL]: EqualPasswordValidator,
  [VALIDATOR_IS_SISENSE_REFRESH]: IsSisenseRefresh,
  [VALIDATOR_IS_LESS_THEN_255_SYMBOLS]: isLessThen255Symbols,
  [VALIDATOR_IS_LONGITUDE]: isLongitude,
  [VALIDATOR_IS_LATITUDE]: isLatitude,
  [VALIDATOR_IS_INVALID_RANGE]: IsInvalidRange,
  [VALIDATOR_CONFIRM_PASSWORD]: isInvalidConfirmPassword,
  /* Сюда добавлять ключ: значение, где ключ - это алиас валидатора, 
    а значение - это имя импортированного класа валидатора */
}

function createValidator(validator, data) {
  if (!Object.prototype.hasOwnProperty.call(validators, validator)) {
    throw new Error(`Validator '${validator}' not exist`)
  }

  return new validators[validator](data)
}

export default function getValidator(validator, data = {}) {
  if (!(data instanceof Object)) {
    throw new Error('Argument data is not Object')
  }

  return (value, allValues) => {
    let validatorName = null
    let error = null
    // eslint-disable-next-line no-param-reassign
    validator = !Array.isArray(validator) ? [validator] : validator

    // eslint-disable-next-line no-param-reassign, guard-for-in
    for (const i in validator) {
      validatorName = validator[i]

      if (validatorName !== VALIDATOR_IS_EMPTY && !value) {
        // eslint-disable-next-line no-continue
        continue
      }

      error = createValidator(
        validatorName,
        Object.assign(data, { value, allValues }),
      ).validate()

      if (error) {
        return error
      }
    }

    return null
  }
}
